import { render, staticRenderFns } from "./CreatePackingForm.vue?vue&type=template&id=93b4e7da&"
import script from "./CreatePackingForm.vue?vue&type=script&lang=js&"
export * from "./CreatePackingForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports